(function () {
  if (window.__balHome) return;
  window.__balHome = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function proofInit(root) {
    var dataEl = document.querySelector('script[data-bal-proof]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var ring = data.ring, vids = data.videos, quotes = data.quotes;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bal-card]'));
    if (!cards.length) return;
    var half = Math.floor(cards.length / 2);
    var p = 2;
    function render(anim) {
      cards.forEach(function (c, j) {
        var vi = ring[(((p + j - half) % 5) + 5) % 5];
        var v = vids[vi];
        c.dataset.balVideo = vi;
        c.setAttribute('aria-label', (j === half ? 'Play video from ' : 'Show video from ') + v.name + ', ' + v.prod);
        var img = c.querySelector('[data-bal-img]');
        if (img) {
          var swap = function () { img.src = v.img; img.alt = v.name + ' wearing ' + v.prod; img.style.objectPosition = v.pos; img.style.opacity = 1; };
          if (anim && !reduce && img.getAttribute('src') !== v.img) { img.style.transition = 'opacity .3s ease'; img.style.opacity = 0; setTimeout(swap, 200); } else swap();
        }
        var n = c.querySelector('[data-bal-name]'); if (n) n.textContent = v.name;
        var pr = c.querySelector('[data-bal-prod]'); if (pr) pr.textContent = v.prod;
      });
      var qi = (((p - 2) % quotes.length) + quotes.length) % quotes.length;
      var qe = root.querySelector('[data-bal-quote]'), we = root.querySelector('[data-bal-reviewer]');
      var apply = function () {
        if (qe) qe.innerHTML = '&ldquo;' + quotes[qi].q + '&rdquo;';
        if (we) we.innerHTML = quotes[qi].who;
      };
      if (anim && !reduce && qe && we) {
        [qe, we].forEach(function (e) { e.style.transition = 'opacity .3s ease'; e.style.opacity = 0; });
        setTimeout(function () { apply(); [qe, we].forEach(function (e) { e.style.opacity = 1; }); }, 240);
      } else apply();
      var ds = root.querySelectorAll('[data-bal-dashes] span');
      Array.prototype.forEach.call(ds, function (s, k) {
        s.style.transition = reduce ? 'none' : 'width .4s ease, background .4s ease';
        s.style.width = (k === qi ? 26 : 14) + 'px';
        s.style.background = k === qi ? '#D0D8AD' : 'rgba(229,225,230,0.24)';
      });
    }
    function go(dir) { p = (((p + dir) % 5) + 5) % 5; render(true); }
    cards.forEach(function (c, j) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        if (j === half) openVideo(vids[c.dataset.balVideo]); else { p = (((p + j - half) % 5) + 5) % 5; render(true); }
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-bal-proof-dir]'), function (b) {
      b.addEventListener('click', function () { go(+b.dataset.balProofDir); });
    });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });
    render(false);
  }

  var modal;
  function openVideo(v) {
    if (!modal) {
      modal = document.createElement('dialog');
      modal.className = 'bal-modal';
      modal.innerHTML = '<div style="position:relative"><button type="button" aria-label="Close video">&times;</button><video controls playsinline></video></div>';
      document.body.appendChild(modal);
      modal.querySelector('button').addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
      modal.addEventListener('close', function () { var vd = modal.querySelector('video'); vd.pause(); vd.removeAttribute('src'); vd.load(); });
    }
    var vd = modal.querySelector('video');
    vd.src = v.video; vd.poster = v.img;
    modal.showModal();
    var pr = vd.play(); if (pr && pr.catch) pr.catch(function () {});
  }

  function motion() {
    if (reduce || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('bal-js');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        t.classList.add('is-in');
        if (t.__balFill) t.__balFill.style.width = t.__balFill.dataset.t;
        io.unobserve(t);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.bal-home section').forEach(function (sec) {
      if (sec.querySelector('h1')) return;
      var set = [], k = 0;
      function add(el) { if (el && set.indexOf(el) < 0) set.push(el); }
      sec.querySelectorAll('h2').forEach(function (h) {
        add(h);
        var pv = h.previousElementSibling; if (pv && pv.tagName === 'DIV') add(pv);
        var nx = h.nextElementSibling; if (nx && (nx.tagName === 'P' || nx.tagName === 'DIV')) add(nx);
      });
      sec.querySelectorAll(':scope > p, .sc, a[href*="-lens"], a[href="/collections/entire-collection"], a[href*="goaffpro"]').forEach(add);
      set.forEach(function (el) {
        el.classList.add('bal-rv');
        el.style.transitionDelay = (k % 5) * 70 + 'ms'; k++;
        io.observe(el);
      });
    });
    document.querySelectorAll('.bal-home span[style*="height:4px"] > span').forEach(function (f) {
      var track = f.parentNode;
      f.setAttribute('data-bal-fill', '');
      f.dataset.t = f.style.width;
      f.style.width = '0';
      track.__balFill = f;
      io.observe(track);
    });
    document.querySelectorAll('.bal-home img[alt^="Kurtis and Racquel"]').forEach(function (i) { io.observe(i); });
  }

  function init() {
    document.querySelectorAll('.bal-home').forEach(function (root) {
      if (root.querySelector('[data-bal-card]')) proofInit(root);
    });
    motion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bal-dir]');
    if (b) {
      var sec = b.closest('section');
      var rail = sec && sec.querySelector('.rail');
      if (rail) {
        var card = rail.querySelector('.sc');
        var w = card ? card.getBoundingClientRect().width + 24 : 300;
        rail.scrollBy({ left: (+b.dataset.balDir) * w * 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      return;
    }
    var chip = e.target.closest('[data-bal-chip]');
    if (chip) {
      var wrap = chip.closest('section');
      wrap.querySelectorAll('[data-bal-chip]').forEach(function (c) {
        var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      wrap.querySelectorAll('[data-bal-panel]').forEach(function (pn) {
        var show = pn.dataset.balPanel === chip.dataset.balChip;
        pn.hidden = !show;
        if (show && !reduce) {
          pn.querySelectorAll('[data-bal-fill]').forEach(function (f) { f.style.width = '0'; void f.offsetWidth; f.style.width = f.dataset.t; });
        }
      });
    }
  });
})();